<div class="chart-header">Users Activity</div>
<div class="chart-content-wrapper">
    <div class="pie-chart-container" [style.width.px]="440">
        <ngx-charts-pie-chart
            [results]="pieData"
            [view]="[440, 250]"
            [legend]="true"
            [labels]="true"
            [doughnut]="true"
            [explodeSlices]="false"
            [legend]="showLegend"
            [scheme]="customColorsSchema"
            [trimLabels]="false"
        >
        </ngx-charts-pie-chart>
        <div class="pie-chart-center">
            <p class="pie-chart-center-label">
                Current logged in users
            </p>
            <p class="pie-chart-center-value">
                {{ currentUsersCount }}
            </p>
        </div>
    </div>  
    <div class="user-stats-wrapper">
        <ul class="users-stats-list">
            <li [style.color]="item.color" *ngFor="let item of flattenedPieData">
                <div class="users-stats-item">
                    <div>{{ item.name }}</div>
                    <div>{{ item.value }}</div>
                </div>
            </li>
        </ul>
        <div class="users-stats-total">
            <div>Total Users</div>
            <div>{{ totalUsersCount }}</div>
        </div>
    </div>
</div>
